module.exports = __webpack_public_path__ + "static/media/Laura.78de0ef8.png";